import React, { SVGProps } from 'react'
const SvgPencilIcon = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || '#1B2C4F'}
      stroke={props.stroke || 'var(--color-cta)'}
      strokeWidth={0.727}
      d="M11.817 2.103a.815.815 0 0 1 .968-.14l.127.087.057.053h.001l1.594 1.593c.299.3.317.77.056 1.091l-.056.063-1.248 1.248L5.79 13.43a.13.13 0 0 1-.07.035l-.04.004H3.334a.14.14 0 0 1-.135-.116l-.002-.045v-2.34q0-.042.024-.076l.019-.023 7.326-7.516zm-1.406 1.8L3.573 10.92l-.103.105v2.173h2.171l.106-.103 7.015-6.84.265-.256-.26-.26L10.927 3.9l-.26-.26zm2.297-1.667a.54.54 0 0 0-.584-.028l-.02.012-.059.044-.018.014-1.167 1.167.257.257 1.846 1.848.258.257.257-.257.894-.893c.14-.14.188-.34.14-.521l-.006-.024-.008-.022-.018-.043-.019-.045-.058-.076-.015-.02-.016-.016-1.595-1.594z"
    />
  </svg>
)
export default SvgPencilIcon
